module.exports = __webpack_public_path__ + "img/bg.9875f655.png";